import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideClientHydration,
  withEventReplay
} from '@angular/platform-browser';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';
import {
  consentEffects,
  consentFeature,
  FIREBASE_CONFIG,
  FirebaseConfig,
  mapaApiInterceptor,
  provideGTM,
  provideMapaImageLoader,
  uiEffects,
  uiFeature
} from '@mapa/ngx';
import {
  provideEffects
} from '@ngrx/effects';
import {
  provideState,
  provideStore
} from '@ngrx/store';
import {
  provideStoreDevtools
} from '@ngrx/store-devtools';
import {
  appRoutes
} from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(withEventReplay()),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),

    provideHttpClient(
      withInterceptors([
        mapaApiInterceptor
      ])
    ),
    provideMapaImageLoader(),

    provideRouter(
      appRoutes,
      // withViewTransitions(),
      withComponentInputBinding(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      })
    ),

    provideGTM('GTM-MJR58HFF'),

    provideStore(),
    provideEffects(),
    provideStoreDevtools({
      name: 'mapa',
      logOnly: true
    }),

    provideState(uiFeature),
    provideEffects(uiEffects),

    provideState(consentFeature),
    provideEffects(consentEffects),

    {
      provide: FIREBASE_CONFIG,
      useValue: {
        apiKey: "AIzaSyCDcrJaWeIeNBChDSuijojEF7zYU-qONKU",
        authDomain: "vital-ensign-469015-q6.firebaseapp.com",
        projectId: "vital-ensign-469015-q6",
        storageBucket: "vital-ensign-469015-q6.firebasestorage.app",
        messagingSenderId: "501381489399",
        appId: "1:501381489399:web:58ba14fb6ca150c96ee9f2",
        functionsRegion: "europe-west2",
        emulator: {
          enabled: false,
          host: 'localhost',
          port: 5001
        }
      } as FirebaseConfig
    }
  ],
};
